import fetchAPI from './fetchAPI';

const getFormStatusesById = formId => {
  return fetchAPI(`/forms/v1/forms/${formId}`).then(
    ({ customStatuses = [] }) => {
      const result = {};
      customStatuses.forEach(one => {
        result[one.internalId] = one.label;
      });
      return result;
    }
  );
};

export default getFormStatusesById;
